// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  hmr: false,
  //version: env.npm_package_version + '-dev',
  ONLINE_BASE_URL: 'https://debo.kavanatech.net/api/',
  ONLINE_UPLOAD_URL: 'https://debo.kavanatech.net',
  /*   ONLINE_BASE_URL: 'https://debo.kavanatech.net/api/',
    ONLINE_UPLOAD_URL: 'https://debo.kavanatech.net/', */
  LOCAL_BASE_URL: 'https://debo.kavanatech.net/api/',
  LOCAL_UPLOAD_URL: 'http://localhost:8000/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
